module.exports = __webpack_public_path__ + "img/ico-notice-webinar.ee9d84e2.svg";